import React from 'react';
import * as S from './styles';

const InputCheckbox = React.forwardRef(
  ({ name, label, error, required = false, onChange, checked, ...rest }, ref) => {
    return (
      <S.CheckboxWrapper>
        <S.CheckboxLabel>
          <S.Checkbox
            ref={ref}
            id={name}
            name={name}
            type="checkbox"
            required={required}
            onChange={onChange}
            checked={checked}
            {...rest}
          />
          <span>{label}</span>
        </S.CheckboxLabel>
        {error && <S.Error>{error}</S.Error>}
      </S.CheckboxWrapper>
    );
  },
);

InputCheckbox.displayName = 'InputCheckbox';

export default InputCheckbox;
